import React from "react";

type DividerProps = {
	direction?: "horizontal" | "vertical";
	borderColor?: string;
};

function Divider({
	direction = "vertical",
	borderColor = "#000000",
}: DividerProps) {
	return (
		<div
			style={
				direction === "vertical"
					? {
							borderLeft: `1px solid ${borderColor}`,
							height: "100%",
					  }
					: {
							borderTop: `1px solid ${borderColor}`,
							width: "100%",
					  }
			}
		/>
	);
}

export default Divider;
